export enum SortByKey {
  Title = 'title',
  Subject = 'subject',
  User = 'user',
  CreatedAt = 'createdAt',
}

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}
